/**
 * Component for rendering a content section with lessons and topics
 */

import React from 'react'
import { List, Input, Icon, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'
import ActionItems from './ActionItems'

const TopicItem = SortableElement(({ children }) => {
  return <div className="sortableHelper">{children}</div>
})

const TopicsContainer = SortableContainer(({ children }) => {
  return (
    <div className="ai-course__table-of-content__lesson-topics">{children}</div>
  )
})

const ContentSection = ({
  content,
  isModalVisible,
  editTopicStatus,
  editTopicIndex,
  editTopicTopIndex,
  newTitle,
  onNewTitleChange,
  onEdit,
  onSaveEdit,
  onCancelEdit,
  onDelete,
  onViewContent,
  onShowImages,
  onSortTopicsEnd,
  onAddTopic,
  isGeneratingContent
}) => {
  const { t } = useTranslation()

  return (
    <div className="ai-course__table-of-content__section">
      {Object.entries(content).map(([sectionTitle, subsections], nindex) => (
        <div key={sectionTitle} className="section">
          <List.Item
            className={`ai-course__table-of-content__lesson-title ${
              isModalVisible && editTopicStatus && editTopicTopIndex === nindex
                ? 'edit-ready'
                : ''
            }`}
          >
            {isModalVisible &&
            editTopicStatus &&
            editTopicTopIndex === nindex ? (
              <Input
                size="large"
                value={newTitle}
                onChange={onNewTitleChange}
              />
            ) : (
              <span> {sectionTitle} </span>
            )}

            <ActionItems
              sectionTitle={sectionTitle}
              item={null}
              index={-1}
              tindex={nindex}
              wstatus={true}
              content={content}
              isModalVisible={isModalVisible}
              editTopicStatus={editTopicStatus}
              editTopicIndex={editTopicIndex}
              editTopicTopIndex={editTopicTopIndex}
              onEdit={onEdit}
              onSaveEdit={onSaveEdit}
              onCancelEdit={onCancelEdit}
              onDelete={onDelete}
              onViewContent={onViewContent}
              onShowImages={onShowImages}
              isGeneratingContent={isGeneratingContent}
            />
          </List.Item>
          <div>
            <TopicsContainer
              distance={1}
              onSortEnd={({ oldIndex, newIndex }) =>
                onSortTopicsEnd({ sectionTitle, oldIndex, newIndex })
              }
              useDragHandle={isGeneratingContent}
              lockAxis="y"
              axis="y"
              lockToContainerEdges={true}
            >
              {Object.keys(subsections).map((item, index) => (
                <TopicItem key={item} index={index}>
                  <div
                    className={`ai-course__table-of-content__lesson-topic ${
                      isModalVisible &&
                      editTopicTopIndex === nindex &&
                      editTopicIndex === index
                        ? 'edit-ready'
                        : ''
                    }`}
                  >
                    <span>
                      {isModalVisible &&
                      editTopicTopIndex === nindex &&
                      editTopicIndex === index ? (
                        <Input
                          size="large"
                          value={newTitle}
                          onChange={onNewTitleChange}
                        />
                      ) : (
                        item
                      )}

                      {subsections[item].generatedContent &&
                        (() => {
                          const gen = subsections[item].generatedContent
                          const noContent =
                            typeof gen === 'string' &&
                            (gen.indexOf('I did not find any content') !== -1 ||
                              gen.length < 50)
                          return (
                            <Tooltip
                              title={
                                noContent
                                  ? t('v5:no_content_found')
                                  : t('v4:content_has_been_generated')
                              }
                            >
                              <Icon
                                type={
                                  noContent
                                    ? 'exclamation-circle'
                                    : 'check-circle'
                                }
                                style={{
                                  color: noContent ? 'orange' : 'green'
                                }}
                              />
                            </Tooltip>
                          )
                        })()}
                    </span>
                    {isGeneratingContent &&
                    !subsections[item].generatedContent ? (
                      <Icon type="loading" />
                    ) : (
                      <ActionItems
                        sectionTitle={sectionTitle}
                        item={item}
                        index={index}
                        tindex={nindex}
                        wstatus={false}
                        content={content}
                        isModalVisible={isModalVisible}
                        editTopicStatus={editTopicStatus}
                        editTopicIndex={editTopicIndex}
                        editTopicTopIndex={editTopicTopIndex}
                        onEdit={onEdit}
                        onSaveEdit={onSaveEdit}
                        onCancelEdit={onCancelEdit}
                        onDelete={onDelete}
                        onViewContent={onViewContent}
                        onShowImages={onShowImages}
                        isGeneratingContent={isGeneratingContent}
                      />
                    )}
                  </div>
                </TopicItem>
              ))}
            </TopicsContainer>
          </div>
          {!isGeneratingContent && (
            <span
              className="ai-course__table-of-content__add-topic"
              onClick={() => onAddTopic(sectionTitle)}
            >
              {t('v3:ai_add_topic')}
            </span>
          )}
        </div>
      ))}
    </div>
  )
}

export default ContentSection
